'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Host = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.wwwUrl = wwwUrl;
exports.stayUrl = stayUrl;
exports.stayAmpUrl = stayAmpUrl;
exports.dashboardUrl = dashboardUrl;
exports.accountUrl = accountUrl;
exports.eventUrl = eventUrl;
exports.googleMapUrl = googleMapUrl;
exports.helpUrl = helpUrl;
exports.helpPaymentUrl = helpPaymentUrl;
exports.helpBillingUrl = helpBillingUrl;
exports.businessBaseUrl = businessBaseUrl;
exports.businessUrl = businessUrl;
exports.businessSummaryUrl = businessSummaryUrl;
exports.isCurrentPage = isCurrentPage;
exports.accountLoginUrl = accountLoginUrl;
exports.accountLogoutUrl = accountLogoutUrl;
exports.accountSignUpUrl = accountSignUpUrl;

var _map = require('../constants/map');

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Host = exports.Host = function () {
  function Host() {
    _classCallCheck(this, Host);
  }

  _createClass(Host, null, [{
    key: 'configureDefaultDev',
    value: function configureDefaultDev() {
      Host.rental = 'https://sandbox.spacemarket.com';
      Host.stay = 'https://stay-sandbox.spacemarket.com';
      Host.stayAmp = 'https://amp-stay-sandbox.spacemarket.com';
      Host.dashboard = 'https://dashboard-sandbox.spacemarket.com';
      Host.business = 'https://business-sandbox.spacemarket.com';
      Host.account = 'https://account-sandbox.spacemarket.com';
      Host.event = 'https://event-sandbox.spacemarket.com';
    }
  }, {
    key: 'configure',
    value: function configure(config, dev) {
      if (dev) {
        Host.configureDefaultDev();
      }

      if (config.SPM_RENTAL_HOST) {
        Host.rental = config.SPM_RENTAL_HOST;
      }
      if (config.SPM_STAY_HOST) {
        Host.stay = config.SPM_STAY_HOST;
      }
      if (config.SPM_STAY_AMP_HOST) {
        Host.stayAmp = config.SPM_STAY_AMP_HOST;
      }
      if (config.SPM_DASHBOARD_HOST) {
        Host.dashboard = config.SPM_DASHBOARD_HOST;
      }
      if (config.SPM_BUSINESS_HOST) {
        Host.business = config.SPM_BUSINESS_HOST;
      }
      if (config.SPM_ACCOUNT_HOST) {
        Host.account = config.SPM_ACCOUNT_HOST;
      }
      if (config.SPM_EVENT_HOST) {
        Host.event = config.SPM_EVENT_HOST;
      }
    }
  }]);

  return Host;
}();

Host.rental = 'https://www.spacemarket.com';
Host.stay = 'https://stay.spacemarket.com';
Host.stayAmp = 'https://amp-stay.spacemarket.com';
Host.dashboard = 'https://dashboard.spacemarket.com';
Host.business = 'https://business.spacemarket.com';
Host.account = 'https://account.spacemarket.com';
Host.event = 'https://event.spacemarket.com';
Host.help = 'https://help.spacemarket.com';
function wwwUrl(path) {
  return '' + Host.rental + path;
}

function stayUrl(path) {
  return '' + Host.stay + path;
}

function stayAmpUrl(path) {
  return '' + Host.stayAmp + path;
}

function dashboardUrl(owner, path) {
  return Host.dashboard + '/' + owner.username + path;
}

function accountUrl(path, config) {
  var url = '' + Host.account + path;
  if (config) {
    if (config.SPM_SERVICE_ID) {
      url = url + ('?serviceId=' + config.SPM_SERVICE_ID);
    }
    if (config.URL) {
      var prefix = config.SPM_SERVICE_ID ? '&' : '?';
      var done = encodeURIComponent(config.URL);
      url = url + (prefix + 'done=' + done);
    }
  }
  return url;
}

function eventUrl(path) {
  return '' + Host.event + path;
}

function googleMapUrl(latitude, longitude, name) {
  return 'https://www.google.com/maps?q=' + (latitude || _map2.default.defaultLatitude) + ',' + (longitude || _map2.default.defaultLongitude) + '+(' + encodeURIComponent(name || '') + ')';
}

function helpUrl() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return Host.help + '/hc/ja/' + path;
}

function helpPaymentUrl() {
  return helpUrl('articles/217748737');
}

function helpBillingUrl() {
  return helpUrl('articles/218429038');
}

function businessBaseUrl() {
  return Host.business;
}

function businessUrl(path) {
  return '' + businessBaseUrl() + path;
}

function businessSummaryUrl(username) {
  return businessBaseUrl() + '/companies/' + username + '/summaries';
}

function isCurrentPage(path, pattern) {
  var regexp = new RegExp(pattern);
  return path.match(regexp);
}

function accountLoginUrl(config) {
  return accountUrl('/login', config);
}

function accountLogoutUrl(config) {
  return accountUrl('/logout', config);
}

function accountSignUpUrl(config) {
  return accountUrl('/sign_up', config);
}


//////////////////
// WEBPACK FOOTER
// ./~/frontend_core/dist/helpers/url.js
// module id = 55
// module chunks = 0